import { render, staticRenderFns } from "./EscolheSubsecoes.vue?vue&type=template&id=191634d9&scoped=true"
import script from "./EscolheSubsecoes.vue?vue&type=script&lang=js"
export * from "./EscolheSubsecoes.vue?vue&type=script&lang=js"
import style0 from "./EscolheSubsecoes.vue?vue&type=style&index=0&id=191634d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191634d9",
  null
  
)

export default component.exports